<template>
  <div>
      <!-- 头部链接 -->
    <preset-detail></preset-detail>
  </div>
</template>

<script>
import PresetDetail from './components/PresetDetail'
export default {
  components: {
    PresetDetail
  },
  data(){
    return {
    
    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
